import React from 'react';
import { Check } from 'lucide-react';
import { WistiaVideo } from '../components/WistiaVideo';
export function ThankYouPage() {
  return <main className="min-h-screen w-full font-sans selection:bg-[#FF6B00] selection:text-white" data-id="element-2">
      {/* SECTION 1 — CONFIRMACIÓN */}
      <section className="bg-black text-white py-16 md:py-24 px-4" data-id="element-3">
        <div className="max-w-3xl mx-auto" data-id="element-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6 leading-tight" data-id="element-5">
            Tu Mapa de Gestión de Tiempo ya fue enviado a tu correo
          </h1>
          <p className="text-lg md:text-xl text-center text-slate-300 mb-10" data-id="element-6">
            Revisa tu bandeja de entrada y descarga:
          </p>

          <div className="flex justify-center" data-id="element-7">
            <ul className="space-y-4 text-lg md:text-xl text-slate-200" data-id="element-8">
              <li className="flex items-start" data-id="element-9">
                <Check className="h-6 w-6 text-green-400 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-10" />
                <span data-id="element-11">Paso 1 — Instructivo</span>
              </li>
              <li className="flex items-start" data-id="element-12">
                <Check className="h-6 w-6 text-green-400 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-13" />
                <span data-id="element-14">Paso 2 — Mapa de gestión</span>
              </li>
              <li className="flex items-start" data-id="element-15">
                <Check className="h-6 w-6 text-green-400 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-16" />
                <span data-id="element-17">Paso 3 — Tu siguiente paso</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 2 — INSTRUCCIÓN */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-18">
        <div className="max-w-3xl mx-auto text-center" data-id="element-19">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-8" data-id="element-20">
            Antes de cerrar esta página, algo importante:
          </h2>
          <div className="space-y-4 text-lg md:text-xl text-slate-700" data-id="element-21">
            <p data-id="element-22">
              Para que este ejercicio funcione debes hacerlo con honestidad.
            </p>
            <p data-id="element-23">No escribas lo que deberías hacer.</p>
            <p data-id="element-24">Escribe lo que realmente ocurre en tu día.</p>
            <p className="font-semibold text-slate-900" data-id="element-25">
              Solo así podrás detectar las fugas que frenan el crecimiento de tu
              negocio.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 — VIDEO */}
      <section className="bg-slate-50 py-16 md:py-24 px-4 border-y border-slate-100" data-id="element-26">
        <div className="max-w-4xl mx-auto" data-id="element-27">
          <div className="space-y-4 text-lg md:text-xl text-center text-slate-700 mb-12" data-id="element-28">
            <p className="font-semibold text-slate-900" data-id="element-29">
              Lo que estás a punto de ver no es menor.
            </p>
            <p data-id="element-30">
              La mayoría de las personas vive años sin darse cuenta de qué parte
              de su día no genera crecimiento.
            </p>
            <p className="font-semibold text-slate-900" data-id="element-31">Tú lo vas a ver hoy.</p>
          </div>

          <div className="max-w-[800px] mx-auto w-full rounded-xl overflow-hidden shadow-2xl bg-slate-200" data-id="element-32">
            <WistiaVideo mediaId="2t54l671sn" aspectRatio={1.2903225806451613} className="w-full" data-id="element-33" />
          </div>
        </div>
      </section>

      {/* SECTION 4 — REVELACIÓN */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-34">
        <div className="max-w-3xl mx-auto text-center" data-id="element-35">
          <div className="space-y-4 text-lg md:text-xl text-slate-700" data-id="element-36">
            <p data-id="element-37">
              La mayoría de los vendedores cree que su problema es falta de
              tiempo.
            </p>
            <p data-id="element-38">Pero cuando hacen este ejercicio descubren algo diferente:</p>
            <p className="font-semibold text-slate-900 text-xl md:text-2xl mt-6" data-id="element-39">
              Su día está lleno…
            </p>
            <p className="font-semibold text-[#FF6B00] text-xl md:text-2xl" data-id="element-40">
              pero no está generando crecimiento.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 — SIGUIENTE PASO */}
      <section className="bg-slate-50 py-16 md:py-24 px-4 border-y border-slate-100" data-id="element-41">
        <div className="max-w-3xl mx-auto" data-id="element-42">
          <div className="space-y-4 text-lg md:text-xl text-center text-slate-700 mb-10" data-id="element-43">
            <p data-id="element-44">Detectar la fuga cambia tu perspectiva.</p>
            <p data-id="element-45">Pero no cambia tu negocio.</p>
            <p data-id="element-46">Lo que cambia tu negocio es:</p>
            <p className="font-semibold text-slate-900" data-id="element-47">
              dejar de hacer lo que no suma y rediseñar todo alrededor de lo que
              sí
            </p>
          </div>

          <div className="text-center mb-10" data-id="element-48">
            <h3 className="inline-block text-2xl md:text-4xl font-extrabold text-[#FF6B00] bg-orange-50 px-6 py-3 rounded-lg border border-orange-100 shadow-sm" data-id="element-49">
              Juega desde Otro Nivel — Nivel 1
            </h3>
          </div>

          <p className="text-lg md:text-xl text-center text-slate-700 mb-8" data-id="element-50">
            En este entrenamiento aprenderás a:
          </p>

          <div className="flex justify-center mb-12" data-id="element-51">
            <ul className="space-y-4 text-lg md:text-xl text-slate-700" data-id="element-52">
              <li className="flex items-start" data-id="element-53">
                <Check className="h-6 w-6 text-[#FF6B00] mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-54" />
                <span data-id="element-55">identificar el 20% que mueve tu negocio</span>
              </li>
              <li className="flex items-start" data-id="element-56">
                <Check className="h-6 w-6 text-[#FF6B00] mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-57" />
                <span data-id="element-58">reorganizar tu agenda alrededor de ese 20%</span>
              </li>
              <li className="flex items-start" data-id="element-59">
                <Check className="h-6 w-6 text-[#FF6B00] mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-60" />
                <span data-id="element-61">eliminar fugas de tiempo, energía y foco</span>
              </li>
              <li className="flex items-start" data-id="element-62">
                <Check className="h-6 w-6 text-[#FF6B00] mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-63" />
                <span data-id="element-64">convertir la venta en un verdadero negocio</span>
              </li>
            </ul>
          </div>

          <div className="text-center" data-id="element-65">
            <a href="https://jdon.inpactamas.com/" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-[#FF6B00] hover:bg-[#e56000] text-white font-bold text-lg md:text-xl px-8 py-5 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-orange-300 text-center" data-id="element-66">
              QUIERO JUGAR DESDE OTRO NIVEL
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 6 — CIERRE */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-67">
        <div className="max-w-3xl mx-auto text-center" data-id="element-68">
          <div className="space-y-4 text-lg md:text-xl text-slate-700 font-medium" data-id="element-69">
            <p data-id="element-70">Primero detectas la fuga.</p>
            <p data-id="element-71">Después diseñas el crecimiento.</p>
            <p data-id="element-72">Este mapa es solo el primer paso.</p>
            <p className="mt-8 text-slate-900" data-id="element-73">Tu día puede estar lleno…</p>
            <p className="text-[#FF6B00]" data-id="element-74">y aun así tu negocio no crecer.</p>
          </div>
        </div>
      </section>
    </main>;
}